import { Constants } from "config/constants";

const CONVERSION_RESTRICTIONS = {
  "PVT": {
    shareholders: {
      min: {
        value: 1,
        error:
          "At least one shareholder is required for conversion to public company.",
      },
      max: {
        value: 50,
        error: "A private company cannot have more than 50 shareholders.",
      },
    },
    directors: {
      min: {
        value: 2,
        error: (count) =>
          `At least two directors are required for conversion to public company. Please appoint ${
            count === 1 ? "one director" : "at least two directors"
          } to meet this requirement.`,
      },
    },
    companySecretary: {
      min: {
        value: 1,
        error:
          "At least one company secretary is required for conversion to public company.",
      },
    },
    directorsIdTypes: {
      validTypes: [
        Constants.ID_TYPES.KENYAN_CITIZEN,
        Constants.ID_TYPES.FOREIGN_RESIDENT,
        Constants.ID_TYPES.FOREIGNER,
      ],
      error:
        "Company requires at least one Director to be a natural person (KE Citizen, Foreign Resident, or Foreigner).",
    },
  },

  "PLC": {
    shareholders: {
      min: {
        value: 1,
        error:
          "At least one shareholder is required for private to public company conversion.",
      },
    },
    directors: {
      min: {
        value: 2,
        error:
          "At least two directors are required for public to private company conversion.",
      },
    },
    companySecretary: {
      min: {
        value: 1,
        error:
          "At least one company secretary is required for public to private company conversion.",
      },
    },
    directorsIdTypes: {
      validTypes: [
        Constants.ID_TYPES.KENYAN_CITIZEN,
        Constants.ID_TYPES.FOREIGN_RESIDENT,
        Constants.ID_TYPES.FOREIGNER,
      ],
      error:
        "Company requires at least one Director to be a natural person (KE Citizen, Foreign Resident, or Foreigner).",
    },
  },
};

const validateCompanyConversion = (company, companyOfficials) => {
  const restrictions = CONVERSION_RESTRICTIONS[company?.type];
  const validationState = {
    shareholders: { count: 0 },
    directors: { count: 0 },
    companySecretary: { count: 0 },
    directorsIdTypes: { status: false },
  };

  companyOfficials.forEach(({ designation, idType }) => {
    if (
      [
        Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER,
        Constants.APPLICANT_CAPACITIES.SHAREHOLDER,
        Constants.APPLICANT_CAPACITIES.JOINT_SHAREHOLDER,
      ].includes(designation)
    ) {
      validationState.shareholders.count += 1;
    }

    if (
      [
        Constants.APPLICANT_CAPACITIES.DIRECTOR,
        Constants.APPLICANT_CAPACITIES.DIRECTOR_SHAREHOLDER,
      ].includes(designation)
    ) {
      validationState.directors.count += 1;
      if (restrictions.directorsIdTypes.validTypes.includes(idType)) {
        validationState.directorsIdTypes.status = true;
      }
    }

    if (designation === Constants.APPLICANT_CAPACITIES.COMPANY_SECRETARY) {
      validationState.companySecretary.count += 1;
    }
  });

  const errors = [];

  // Validate minimum requirements
  if (validationState.shareholders.count < restrictions.shareholders.min.value)
    errors.push(restrictions.shareholders.min.error);

  if (validationState.shareholders.count > restrictions.shareholders.max.value)
    errors.push(restrictions.shareholders.max.error);

  if (validationState.directors.count < restrictions.directors.min.value)
    errors.push(
      restrictions.directors.min.error(validationState.directors.count)
    );

  if (
    validationState.companySecretary.count <
    restrictions.companySecretary.min.value
  )
    errors.push(restrictions.companySecretary.min.error);

  if (!validationState.directorsIdTypes.status)
    errors.push(restrictions.directorsIdTypes.error);

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export default validateCompanyConversion;
